import React from "react";
import ResultWrapper from "./ResultWrapper";

function Results({ results, searchDuration }) {
  return (
    <div className="mt-4">
      <div className="mb-3">
        <small className="text-muted">
          About {results.length} results ({searchDuration})
        </small>
      </div>
      {results.map((result) => (
        <ResultWrapper result={result} key={`${result.model_gid}-${result.embedding_type}`} />
      ))}
    </div>
  );
}

export default Results;
